import { IframeHTMLAttributes, forwardRef } from "react";
import { useSelector } from "react-redux";

import { Alert } from "@livechat/design-system-react-components";

import { useChatWidget } from "hooks/use-chat-widget";
import { selectIsGhostLogin } from "store/features/session";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const GhostLoginAlert = () => {
  const { openChatWidget } = useChatWidget();
  return (
    <Alert
      kind="warning"
      primaryButton={{
        label: "Chat with support",
        handleClick: openChatWidget,
      }}
      data-testid="ghost-login-alert"
    >
      <code>iframe</code> blocked for security reasons (this is a ghost login section). Think this is a mistake?
    </Alert>
  );
};

export const SafeIframe = forwardRef<HTMLIFrameElement, IframeHTMLAttributes<HTMLIFrameElement>>(
  ({ ...restProps }, ref) => {
    const isGhost = useSelector(selectIsGhostLogin);

    if (isGhost) {
      return <GhostLoginAlert />;
    }

    return <iframe ref={ref} {...restProps} />;
  }
);

SafeIframe.displayName = "SafeIframe";
